import React from 'react'
import AccountsCompont from '../../components/Accounts/AccountsCompont'

const Accounts = () => {
  return (
    <div>
        <AccountsCompont/>
    </div>
  )
}

export default Accounts